import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './newIndex.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
// import { UserInfoContextProvider } from './ContextApi';
import { DataContextProvider } from './DataContextProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <DataContextProvider>
    <React.StrictMode>
    <Router>
      <App/>
    </Router>
  </React.StrictMode>
  </DataContextProvider>
);